@if (isV2) {
  <router-outlet />
} @else {
  <app-header (toggleMenu)="toggleMenu()" [isMenuOpen]="!isCollapsed" [hideHeader]="hideHeader" />
  <app-toasts />

  <div class="app-layout">
    @if (!hideHeader) {
    <aside class="app-sider" [class.collapsed]="isCollapsed">
      <ul class="sidebar-nav">
        @if (isAdmin$ | async) {
        <div>
          <li class="nav-title">BRIEFINGS</li>
          <li><a routerLink="/classic/airport-admin">Airport Management</a></li>
          <li><a routerLink="/classic/handler-info-admin">Handler Management</a></li>
          <li><a routerLink="/classic/feedback-admin">Feedback Management</a></li>
          <li class="nav-title"> PRICE ESTIMATOR </li>
          <li><a routerLink="/classic/airport-fees-admin">Airport Fees Management</a></li>
          <li><a routerLink="/classic/handler-fees">Handler Fees Management</a></li>
          <li><a routerLink="/classic/cost-estimator">Estimator</a></li>
          <li><a routerLink="/classic/evo-tariffs">EVO Tariffs</a></li>
          <li><a routerLink="/classic/aircraft">Aircraft Types</a></li>
          <li><a routerLink="/classic/faq">Estimator FAQ</a></li>
          <li class="nav-title"> SETTINGS </li>
          <li><a routerLink="/classic/accounts">Accounts</a></li>
        </div>
        }
        <li class="nav-title">
          EVO Apps
        </li>
        <li>
          <a routerLink="/">Back to the new layout</a>
        </li>
        <li>
          <a href="https://apps.evo-jet.com/fuel/search/airports" target="_blank">
            Fuel Web
          </a>
        </li>
        <li>
          <a href="https://www.flight-compass.com/trips/" target="_blank">
            Flight Compass
          </a>
        </li>
        <li>
          <a routerLink="/classic">
            Airport Fee Estimator
          </a>
        </li>
        <li>
          <!--
            An absolute URL on the briefings host, not a routerLink. Traefik
            301s /classic/airport-briefings to briefings.flyevo.com/ on a hard
            load, so a routerLink here made the app and the edge disagree about
            the same URL: typing it went to the briefings host, clicking it
            rendered the legacy list on the estimator.
          -->
          <a [href]="briefingsHref">
            Airport Briefings
          </a>
        </li>
        <li>
          <a href="https://flyevo.com/airport-briefing-app/" target="_blank">
            3D Airport Briefing
          </a>
        </li>
        <li>
          <a href="https://notams.flyevo.com/" target="_blank">
            NOTAMizer
          </a>
        </li>
        @if (!(isAdmin$ | async)) {
        <li class="nav-title">
          24/7 OPS CENTER
        </li>
        <li>
          <a href="tel:+14154046104">
            +1 415 404 6104
          </a>
        </li>
        <li>
          <a href="mailto:opscenter@flyevo.com">
            opscenter&#64;flyevo.com
          </a>
        </li>
        <li class="nav-title">
          24/7 FUEL DISPATCH
        </li>
        <li>
          <a href="tel:+14154046133">
            +1 415 404 6133
          </a>
        </li>
        <li>
          <a href="mailto:orderfuel@flyevo.com">
            orderfuel&#64;flyevo.com
          </a>
        </li>
        }
      </ul>
    </aside>
    }

    <div class="app-main">
      @if (breadcrumbs && !hideHeader) {
      <h1 class="main-static-title">
        EVO Apps / {{breadcrumbs}}
      </h1>
      }
      <main class="app-content">
        <router-outlet />
      </main>
      <footer class="app-footer">
        <ul>
          <li>
            <a href="https://flyevo.com/privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>
            <a href="https://flyevo.com/terms-of-service" target="_blank">Terms of Service</a>
          </li>
        </ul>
      </footer>
    </div>

  </div>
}
